import React, { Fragment, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser"
import { sanitizeHtml } from "../../utils/sanitize";

import { useAlert } from "react-alert";
import moment from "moment";
import Countdown, {
    zeroPad,
} from "react-countdown";

import Loader from "../Loader";
import ProgressBarLoader from "../Loader/ProgressBarLoader";
import { userAvatarUrl, questionImageUrl, localAssetUrl } from "../../utils/assets";
import { submitExamResult } from "./../../actions/resultActions";
import { SUBMIT_RESULT_RESET } from "./../../constants/resultConstants";

import "./mock.css";

import { getMockExamQuestions } from "../../actions/mockActions";
import Modal from "../Modal/Modal";
import Calculator from "../Calculator/Calculator";
import {
    FIVE_MINUTE_WARNING_MESSAGE,
    shouldWarnFiveMinutesLeft,
} from "../../utils/examTimeWarning";

const ObjectiveExam = ({ history }) => {
    const alert = useAlert();
    const dispatch = useDispatch();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [checked, setChecked] = useState(false);
    const fiveMinuteWarningShown = useRef(false);

    const { user, loading, error } = useSelector((state) => state.auth);
    const userId = user?._id || null;

    const examId = localStorage.getItem("examId");
    const examType = localStorage.getItem("examType");
    const subjects = localStorage.getItem("subjects");
    const year = localStorage.getItem("year");
    const shuffleQuestions = localStorage.getItem("shuffleQuestions");
    const shuffleOptions = localStorage.getItem("shuffleOptions");
    // alert.info(timeDuration);
    //var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
    const assessmentId = localStorage.getItem("assessmentId");
    const assessmentType = localStorage.getItem("assessmentSlug");

    useEffect(() => {
        const questionCount = localStorage.getItem('questionCount');
        const subscriptionId = localStorage.getItem('userSubscription');
        dispatch(getMockExamQuestions(examId, examType, subjects,"", questionCount,subscriptionId));
    }, [alert, dispatch, examId, subjects, user]);

    const { mloading, mockQuestions, examData, questionCount } = useSelector(
        (state) => state.mockList
    );

    const [showCalculator, setShowCalculator] = useState(false);

    const [totalQuestions, setTotalQuestions] = useState(0);

    const [currentSubject, setCurrentSubject] = useState(0);

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);

    const [answered, setAnswered] = useState([]);
    const [markForReviewed, setMarkForReviewed] = useState([]);

    const [showResults, setShowResults] = useState(false);
    const [rightAnswer, setRightAnswer] = useState("");
    const [description, setDescription] = useState("")
    const timeDuration = localStorage.getItem("timeDuration");

    const [totalTime, setTotalTime] = useState(
        Date.now() + parseInt(timeDuration) * 60 * 1000
    );
    // const [ totalTime, setTotalTime ] = useState(timeDuration);
    const [quizTotalTime, setQuizTotalTime] = useState("");
    const [remainingTime, setRemainingTime] = useState("");
    const [takenTime, setTakenTime] = useState("");
    // console.log("totalTime", totalTime);
    useEffect(() => {
        if (
            mockQuestions !== undefined &&
            mockQuestions.length > 0 &&
            mockQuestions[0].questions !== undefined &&
            mockQuestions[0].questions.length > 0
        ) {
            // var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
            // setTotalTime(timerData);

            setTotalQuestions(questionCount);
            setNumberOfQuestions(mockQuestions[0].questions.length);
            // alert.success(numberOfQuestions);
        }
    }, [mockQuestions, currentQuestion, questionCount, rightAnswer]);

    const [selections, setSelections] = useState(
        mockQuestions !== undefined && mockQuestions.length > 0
            ? [Object.keys(mockQuestions).map((x) => [])]
            : []
    );

    const handleSubjectType = (e) => {
        e.preventDefault();
        const currentIndex = parseInt(e.target.dataset.id);

        setCurrentSubject(currentIndex);
        setCurrentQuestion(0);
        // alert.success(currentIndex);
        if (
            mockQuestions !== undefined &&
            mockQuestions.length > 0 &&
            mockQuestions[currentIndex].questions !== undefined &&
            mockQuestions[currentIndex].questions.length > 0
        ) {
            // alert.success(questions[currentIndex].questions.length);
            setNumberOfQuestions(mockQuestions[currentIndex].questions.length);
        }
    };

    // console.log("mockQuestions", mockQuestions);
    const onAnswerOptionChange = (event) => {
        const answerId = event.target.value;
        // alert.success(index);
        const selectedQuestionId = event.target.dataset.questionid;

        if (answered.find((obj) => obj.question === selectedQuestionId)) {
            let tempArr = answered;
            let newAns = tempArr.map((obj) => {
                if (obj.question === selectedQuestionId && obj.answer !== answerId) {
                    return { ...obj, question: selectedQuestionId, answer: answerId };
                }
                else {
                    return obj
                }
            })
            setAnswered(newAns);
        }
        else {
            let answeredArray = [
                ...answered,
                {
                    question: selectedQuestionId,
                    answer: answerId
                },
            ];
            setAnswered(answeredArray);
        }
        // let answeredArray = [
        //     ...answered,
        //     {
        //         question: selectedQuestionId,
        //         answer: event.target.value,
        //     },
        // ];
        // //remove duplicate answer
        // if (answered.some((ans) => ans.answer === event.target.value)) {
        //     answeredArray = answeredArray.filter(
        //         (item) => item.answer !== event.target.value
        //     );
        // }
        // //remove duplicate question
        // if (
        //     answered.some((ques) => ques.question === selectedQuestionId) &&
        //     answered.some((ques1) => ques1.answer !== event.target.value)
        // ) {
        //     answeredArray = answeredArray.filter((qItem) => {
        //         return (
        //             qItem.question !== selectedQuestionId
        //             // qItem.answer !== event.target.value
        //         );
        //     });
        //     answeredArray = [
        //         ...answeredArray,
        //         {
        //             question: selectedQuestionId,
        //             answer: event.target.value,
        //         },
        //     ];
        // }
        // setAnswered(answeredArray);

        if (selections[answerId]) {
            delete selections[answerId]
        }
        // set selection
        let tempState = { ...selections };
        tempState[answerId] = answerId;
        setSelections(tempState);
    };

    const handleNextQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) + 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);
    };
    // console.log(currentQuestion, numberOfQuestions);
    const handlePreviousQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) - 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);
    };

    const getNextSubjectIndex = (fromIndex = currentSubject) => {
        if (!Array.isArray(mockQuestions) || mockQuestions.length <= 1) return -1;
        for (let i = parseInt(fromIndex, 10) + 1; i < mockQuestions.length; i += 1) {
            const subject = mockQuestions[i];
            if (Array.isArray(subject?.questions) && subject.questions.length > 0) {
                return i;
            }
        }
        return -1;
    };

    const handleNextSubjectClick = (e) => {
        e.preventDefault();
        const nextIndex = getNextSubjectIndex();
        if (nextIndex < 0) return;

        setCurrentSubject(nextIndex);
        setCurrentQuestion(0);
        setShowResults(false);
        const nextSubject = mockQuestions[nextIndex];
        if (Array.isArray(nextSubject?.questions) && nextSubject.questions.length > 0) {
            setNumberOfQuestions(nextSubject.questions.length);
        }
    };

    const handleViewAnswer = (e) => {
        //alert.success(numberOfQuestions);
        e.preventDefault();
        if (
            mockQuestions !== undefined &&
            mockQuestions.length > 0 &&
            mockQuestions[currentSubject].questions !== undefined &&
            mockQuestions[currentSubject].questions.length > 0
        ) {
            const currentAns =
                mockQuestions[currentSubject].questions[currentQuestion].correctAns;
            const correctAnswer = mockQuestions[currentSubject].questions[
                currentQuestion
            ].options.filter((opItem) => opItem._id === currentAns);
            // console.log("correctAnswer ", correctAnswer);
            setRightAnswer(correctAnswer[0].option);
            setDescription(mockQuestions[currentSubject]?.questions[currentQuestion]?.description);
        }
        setShowResults(!showResults);
        // alert.success(rightAnswer);
    };

    const handleFilterQuestion = (e) => {
        e.preventDefault();
        const currentQue = e.target.dataset.id;
        // alert.info(currentQue);
        setCurrentQuestion(currentQue);
        setShowResults(false);
    };

    const handleMarkForReview = (event) => {
        let reviewArray = [...markForReviewed, event.target.value];
        if (markForReviewed.includes(event.target.value)) {
            reviewArray = reviewArray.filter((it) => it !== event.target.value);
        }
        setMarkForReviewed(reviewArray);
        // if (event.target.checked === true) {
        //   setDisabled(false);
        // }
        //alert.success("markForReviewed ", markForReviewed);
    };

    const handleRemainigTime = (data) => {
        // totalTime
        var quizHour = Math.floor(timeDuration / 60);
        quizHour = parseInt(quizHour) >= 10 ? quizHour : "0" + quizHour;
        var quizMinutes = timeDuration % 60 === 0 ? "00" : timeDuration % 60;
        var quizSecond = "00";
        const quizTime = quizHour + ":" + quizMinutes + ":" + quizSecond;

        const remainingMinutes =
            data.minutes < 10 ? "0" + data.minutes : data.minutes; // return minutes
        const remainingSeconds =
            data.seconds < 10 ? "0" + data.seconds : data.seconds;

        const remainTime =
            "0" + data.hours + ":" + remainingMinutes + ":" + remainingSeconds;
        var start = moment.duration(quizTime, "HH:mm:ss");
        var end = moment.duration(remainTime, "HH:mm:ss");
        var diff = start.subtract(end);

        const hour = diff.hours(); // return hours
        const minutes = diff.minutes() < 10 ? "0" + diff.minutes() : diff.minutes(); // return minutes
        const seconds = diff.seconds() < 10 ? "0" + diff.seconds() : diff.seconds();
        const usedTime = "0" + hour + ":" + minutes + ":" + seconds;

        setQuizTotalTime(quizTime);
        setRemainingTime(remainTime);
        setTakenTime(usedTime);

        if (
            shouldWarnFiveMinutesLeft({
                data,
                timeDurationMinutes: timeDuration,
                alreadyWarned: fiveMinuteWarningShown.current,
            })
        ) {
            fiveMinuteWarningShown.current = true;
            alert.info(FIVE_MINUTE_WARNING_MESSAGE, { timeout: 8000 });
        }

        if (remainTime === "00:00:01") {
            alert.info("Time up, your exam is submitting forcefully!!!", {
                onOpen: () => {
                    var arrSubjects = [];
                    mockQuestions.map(function (item) {
                        if (item.questions.length > 0) {
                            //return item.subject;
                            arrSubjects.push(item.subject._id);
                        }
                    });
                    if (answered.length > 0) {
                        dispatch(
                            submitExamResult(
                                userId,
                                examId,
                                answered,
                                assessmentId,
                                arrSubjects,
                                year,
                                totalQuestions,
                                quizTotalTime,
                                remainTime,
                                takenTime,
                                "",
                                examType
                            )
                        );
                    } else {
                        history.push(`/results`);
                    }
                },
            });
        }
    };

    /*if (remainingTime === "00:00:01") {
      alert.info("Time up, your exam is submitting forcefully!!!", {
        onOpen: () => {
          var arrSubjects = [];
          mockQuestions.map(function (item) {
            if (item.questions.length > 0) {
              //return item.subject;
              arrSubjects.push(item.subject._id);
            }
          });

          dispatch(
            submitExamResult(
              userId,
              examId,
              answered,
              assessmentId,
              arrSubjects,
              year,
              totalQuestions,
              quizTotalTime,
              remainingTime,
              takenTime,
              "",
              examType
            )
          );
          // history.push(`/results`);
        },
      });
    }*/

    const handleSubmitAnswer = (e) => {
        setIsSubmitting(true);
        e.preventDefault();
        if (answered.length > 0) {
            if (
                window.confirm(
                    "Do you really want to submit your answer. We recommend you to review your answer before submitting it."
                )
            ) {
                var arrSubjects = [];
                mockQuestions.map(function (item) {
                    if (item.questions.length > 0) {
                        arrSubjects.push(item.subject._id);
                    }
                });
                dispatch(
                    submitExamResult(
                        userId,
                        examId,
                        answered,
                        assessmentId,
                        arrSubjects,
                        year,
                        totalQuestions,
                        quizTotalTime,
                        remainingTime,
                        takenTime,
                        "",
                        examType
                    )
                );
            }
        } else {
            if (
                window.confirm(
                    "You have not answered any questions, your test will be cancelled. do you really want to cancel?"
                )
            ) {
                alert.info("Test has been cancelled.");
                history.push(`/dashboard`);
            }
        }
        return;
    };

    const { rLoading, isSubmitted, result } = useSelector(
        (state) => state.results
    );
    // console.log("result", result);
    useEffect(() => {
        if (isSubmitted === true && isSubmitted != undefined) {
            alert.success("Result successfully submitted.");

            history.push(`/practice-results/${result.quizId}`);
            dispatch({
                type: SUBMIT_RESULT_RESET,
            });
        }
    }, [dispatch, rLoading, isSubmitted, alert]);

    const examGuardsEnabled = (typeof process !== 'undefined' && process.env.REACT_APP_EXAM_GUARDS || 'true') === 'true';
    useEffect(() => {
        if (!examGuardsEnabled) return;
        const handleBeforeUnload = (ev) => {
            ev.preventDefault();
            ev.returnValue = "Are you sure you want to close?";
            return ev.returnValue;
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [examGuardsEnabled]);
    
    const [isActive, setActive] = useState(false);

    // Adjustable font size for passages/questions/options
    const [fontSize, setFontSize] = useState(() => {
        const saved = parseInt(localStorage.getItem('examFontSize') || '16', 10);
        return Math.min(24, Math.max(12, isNaN(saved) ? 16 : saved));
    });
    const changeFontSize = (delta) => {
        setFontSize((prev) => {
            const next = Math.min(24, Math.max(12, prev + delta));
            try { localStorage.setItem('examFontSize', String(next)); } catch (e) {}
            return next;
        });
    };

    const handleToggleMenu = () => {
        setActive(!isActive);
    };

    const activeSubject = mockQuestions?.[currentSubject];
    const activeQuestion = activeSubject?.questions?.[currentQuestion] || null;
    const activeQuestionId = activeQuestion?._id;
    const hasPassage = Boolean(activeQuestion?.passage);
    const normalizeText = (value) =>
        typeof value === "string" ? value.replace(/<[^>]*>/g, "").trim() : "";
    const normalizedTitle = normalizeText(activeQuestion?.title);
    const normalizedQuestion = normalizeText(activeQuestion?.question);
    const hasDistinctTitle = Boolean(
        normalizedTitle &&
        normalizedQuestion &&
        normalizedTitle !== normalizedQuestion
    );
    const shouldShowSubtitle = hasDistinctTitle && !hasPassage;
    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const deriveQuestionBodyHtml = (questionHtml, titleHtml) => {
        if (!questionHtml || !titleHtml) {
            return questionHtml;
        }
        const plainTitle = normalizeText(titleHtml);
        const plainQuestion = normalizeText(questionHtml);
        if (!plainTitle || !plainQuestion) {
            return questionHtml;
        }
        if (!plainQuestion.toLowerCase().startsWith(plainTitle.toLowerCase())) {
            return questionHtml;
        }
        const escapedTitle = escapeRegExp(plainTitle);
        const paragraphPattern = new RegExp(`<p[^>]*>\\s*${escapedTitle}\\s*<\/p>`, "i");
        const strippedParagraph = questionHtml.replace(paragraphPattern, "").trim();
        if (strippedParagraph !== questionHtml) {
            return strippedParagraph;
        }
        const rawPattern = new RegExp(escapedTitle, "i");
        return questionHtml.replace(rawPattern, "").trim();
    };
    const questionBodyHtml = hasDistinctTitle
        ? deriveQuestionBodyHtml(activeQuestion?.question, activeQuestion?.title)
        : activeQuestion?.question;
    const formatLabel = (value) =>
        value
            ? value
                  .replace(/[_-]+/g, " ")
                  .split(" ")
                  .filter(Boolean)
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(" ")
            : "";
    const assessmentLabel = formatLabel(localStorage.getItem("assessmentName"));
    const resolveExamTypeLabel = (value) => {
        const normalized = (value || "").trim().toLowerCase();
        if (!normalized) {
            return "";
        }
        if (normalized === "both") {
            return "Objective";
        }
        return formatLabel(value);
    };
    const examTypeLabel = resolveExamTypeLabel(localStorage.getItem("examType"));
    const yearLabel = localStorage.getItem("year") || "";
    const userFirst = user?.first_name || "";
    const userLast = user?.last_name || "";

    return (
        <div className={isActive ? "menu-open" : null}>
            {mloading ? (
                <div style={{padding:'120px 0'}}>
                    <ProgressBarLoader text="Loading objective questions..." color="#008753" />
                </div>
            ) : (
                <section className="auth-dash-sec fullHt">
                    <div className="left-navigations">
                        <div className="user-exam">
                            <div className="user-pros-exam" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '90px', width: '90px', margin: '0 auto' }}>
                                <img
                                    src={user?.profileImage ? localAssetUrl(`assets/img/${user.profileImage}`) : localAssetUrl('assets/img/user.png')}
                                    alt="user"
                                    style={{ borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', background: '#f3f3f3', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                                />
                            </div>
                            <h4>
                                <b>Name</b>: {userFirst} {userLast}
                            </h4>
                            <div className="user-meta-block">
                                <div className="meta-row">
                                    {assessmentLabel && (
                                        <span className="assessment-label">
                                            <i className="fas fa-book-open" /> {assessmentLabel}
                                        </span>
                                    )}
                                    <span className="calculator-link" onClick={() => setShowCalculator(true)}>
                                        Calculator
                                    </span>
                                </div>
                                {(yearLabel || examTypeLabel) && (
                                    <div className="meta-row meta-row-secondary">
                                        {yearLabel && (
                                            <span className="year-label">
                                                <i className="fas fa-calendar-alt" />
                                                {yearLabel}
                                            </span>
                                        )}
                                        {examTypeLabel && (
                                            <span className="exam-type-label">{examTypeLabel}</span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <Modal title="Calculator" onClose={() => setShowCalculator(false)} show={showCalculator}>
                            <Calculator />
                        </Modal>
                        <div className="bot-examers">
                            {/*<h2>Subjects</h2>*/}
                            <div className="subject-tab">
                                <ul className="nav nav-tabs" role="tablist">
                                    {mockQuestions !== undefined &&
                                        mockQuestions.length > 0 &&
                                        mockQuestions.map((subItem, i) => {
                                            if (subItem.questions.length > 0) {
                                                return (
                                                    <Fragment key={i}>
                                                        <li
                                                            role="presentation"
                                                            className={currentSubject === i ? "active" : ""}
                                                        >
                                                            <a
                                                                href="#"
                                                                data-id={i}
                                                                onClick={handleSubjectType}
                                                            >
                                                                {subItem.subject.title}
                                                            </a>
                                                        </li>
                                                    </Fragment>
                                                );
                                            }
                                        })}
                                </ul>
                            </div>

                            <div className="number-lister">
                                {mockQuestions !== undefined &&
                                    mockQuestions.length > 0 &&
                                    mockQuestions[currentSubject].questions !== undefined &&
                                    mockQuestions[currentSubject].questions.length > 0 &&
                                    [
                                        ...Array(mockQuestions[currentSubject].questions.length),
                                    ].map((e, i) => {
                                        let className = "";
                                        if (
                                            markForReviewed.indexOf(
                                                mockQuestions[currentSubject].questions[i]._id
                                            ) > -1
                                        ) {
                                            className = "markForReviewQuestion";
                                        } else if (
                                            answered.find(
                                                (obj) =>
                                                    obj.question ==
                                                    mockQuestions[currentSubject].questions[i]._id
                                            )
                                        ) {
                                            className = "markForAnsweredQuestion";
                                        } else if (currentQuestion === i) {
                                            className = "isActiveQuestion";
                                        }
                                        return (
                                            <Fragment key={i}>
                                                <a
                                                    className={className}
                                                    href="#"
                                                    data-id={i}
                                                    onClick={handleFilterQuestion}
                                                >
                                                    {i + 1}
                                                </a>{" "}
                                            </Fragment>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                    <div className="nav-togg" onClick={handleToggleMenu}><span></span></div>

                    <div className="right-auth-landing edit-pros">
                        <div className="main-view-content">
                            {assessmentType !== "study" && (
                                <div className="all-ourt-style timer w-80-cust legends-reviews clearfix">
                                    <div className="pull-left legend-label">
                                        <div>Time Remaining</div> &nbsp;&nbsp;
                                        <div>
                                            <Countdown
                                                date={totalTime}
                                                //zeroPadTime={2}
                                                daysInHours={true}
                                                controlled={false}
                                                onTick={handleRemainigTime}
                                            //renderer={renderer}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <Fragment>
                                <div className="all-ourt-style w-80-cust legends-reviews clearfix">
                                    <div className="pull-left legend-label">
                                        <p>
                                            <span style={{ background: "white" }} /> Un Answered
                                        </p>
                                        <p>
                                            <span style={{ background: "green" }} /> Answered
                                        </p>
                                        <p>
                                            <span style={{ background: "red" }} /> Marked for Review
                                        </p>
                                    </div>
                                    <div className="pull-right" style={{display:'inline-flex',alignItems:'center',gap:8}}>
                                        <span style={{fontSize:12,color:'#374151'}}>Text size</span>
                                        <button type="button" onClick={() => changeFontSize(-1)} className="btn view-ans-btn" style={{padding:'4px 8px',lineHeight:1}}>A-</button>
                                        <button type="button" onClick={() => changeFontSize(1)} className="btn view-ans-btn" style={{padding:'4px 8px',lineHeight:1}}>A+</button>
                                    </div>
                                    {activeSubject?.questions &&
                                        activeSubject.questions.length > 0 && (
                                            <div className="pull-right">
                                                <div
                                                    className="boxes"
                                                    style={{ display: "inline-block" }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name={`review-mark-${activeQuestionId || ""}`}
                                                        id={`box-${activeQuestionId || ""}`}
                                                        value={activeQuestionId || ""}
                                                        onChange={handleMarkForReview}
                                                        checked={
                                                            activeQuestionId
                                                                ? markForReviewed.indexOf(activeQuestionId) > -1
                                                                : false
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={`box-${activeQuestionId || ""}`}
                                                    >
                                                        Mark for Review
                                                    </label>
                                                </div>
                                                {/*:<span>(1) Question</span>*/}
                                            </div>
                                        )}
                                </div>

                                {activeSubject?.questions && activeSubject.questions.length > 0 && (
                                    <Fragment>
                                            {hasPassage && activeQuestion?.passage && (
                                                <div className="all-ourt-style w-80-cust work-info exam-set">
                                                    {hasDistinctTitle && activeQuestion?.title && (
                                                        <div className="question-subtitle" style={{fontSize: fontSize, lineHeight: 1.6}}>
                                                            {activeQuestion.title}
                                                        </div>
                                                    )}

                                                    <div className="exam-main-style" style={{fontSize: fontSize}}>
                                                        <div className="answer-selection">
                                                            <div className="cust-redio">
                                                                <div
                                                                    className="question-passage"
                                                                    style={{fontSize: fontSize, lineHeight: 1.6}}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: sanitizeHtml(activeQuestion.passage),
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        <div className="all-ourt-style w-80-cust work-info exam-set">
                                            <div className="all-heads clearfix">
                                                <h2 className="question-title">
                                                    Question {parseInt(currentQuestion) + 1}.
                                                </h2>
                                            </div>

                                            {shouldShowSubtitle && activeQuestion?.title && (
                                                <div className="question-subtitle" style={{fontSize: fontSize, lineHeight: 1.6}}>
                                                    {activeQuestion.title}
                                                </div>
                                            )}

                                            {questionBodyHtml && (
                                                <div className="question-text" style={{fontSize: fontSize, lineHeight: 1.6}}>
                                                    {parse(questionBodyHtml)}
                                                </div>
                                            )}

                                            {activeQuestion?.logo && (
                                                    <Fragment>
                                                        <img
                                                            src={questionImageUrl(
                                                                activeQuestion.logo
                                                            )}
                                                            alt={activeQuestion.logo}
                                                            style={{ height: "200px" }}
                                                        />
                                                    </Fragment>

                                                )}

                                            <div className="exam-main-style" style={{fontSize: fontSize}}>
                                                <div className="answer-selection">
                                                    <div className="cust-redio">
                                                        {activeQuestion?.options !== undefined &&
                                                            activeQuestion.options.length > 0
                                                            ? activeQuestion.options.map((answerOption, key) => {
                                                                if (answerOption.option !== "") {
                                                                    const indexId = key + 1;
                                                                    return (
                                                                        <Fragment key={indexId}>
                                                                            <label htmlFor={`option-${indexId}`}>
                                                                                <input
                                                                                    type="radio"
                                                                                    name={`option-${activeQuestionId}`}
                                                                                    id={`option-${indexId}`}
                                                                                    value={answerOption._id}
                                                                                    //value={`${questions[currentQuestion]._id}-${answerOption._id}`}
                                                                                    // onClick={onChange}
                                                                                    onChange={(e) =>
                                                                                        onAnswerOptionChange(e)
                                                                                    }
                                                                                    data-questionid={
                                                                                        activeQuestionId
                                                                                    }
                                                                                    checked={
                                                                                        answered && answered?.find((obj) => obj?.question === activeQuestionId)?.answer === answerOption._id
                                                                                        // selections[
                                                                                        // answerOption._id
                                                                                        // ] === answerOption._id
                                                                                    }
                                                                                // checked={
                                                                                //     selections[answerOption._id] ===
                                                                                //     answerOption._id
                                                                                // }
                                                                                />
                                                                                <span style={{fontSize: fontSize, lineHeight: 1.6}}>{parse(answerOption.option)}</span>
                                                                            </label>
                                                                        </Fragment>
                                                                    );
                                                                }
                                                            })
                                                            : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </Fragment>

                            <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                                {assessmentType === "study" && (
                                    <div className="pull-left">
                                        <button
                                            type="button"
                                            className="btn view-ans-btn"
                                            onClick={handleViewAnswer}
                                        >
                                            {!showResults ? "View Answer" : "Hide Answer"}
                                        </button>
                                        {rightAnswer !== undefined && showResults && (
                                            <>
                                                <div className="correct-answer">{parse(rightAnswer)}</div>
                                                <p className="correct-answer">{parse(description)}</p>
                                            </>
                                        )}
                                    </div>
                                )}
                                <div className="pull-right">
                                    {currentQuestion > 0 && (
                                        <button
                                            type="submit"
                                            className="btn nxt-prv"
                                            onClick={handlePreviousQuestionClick}
                                        >
                                            <i className="fas fa-angle-left" /> Prev
                                        </button>
                                    )}

                                    {currentQuestion < numberOfQuestions - 1 && (
                                        <button
                                            type="submit"
                                            className="btn nxt-prv"
                                            //disabled={!answer}
                                            onClick={handleNextQuestionClick}
                                        >
                                            Next <i className="fas fa-angle-right" />
                                        </button>
                                    )}
                                    {currentQuestion >= numberOfQuestions - 1 &&
                                        getNextSubjectIndex() >= 0 && (
                                        <button
                                            type="button"
                                            className="btn nxt-prv"
                                            onClick={handleNextSubjectClick}
                                        >
                                            Next subject <i className="fas fa-angle-right" />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                                <div className="pull-left" />
                                <div className="pull-right">
                                    <button
                                        type="submit"
                                        className="btn submit-ans-btn"
                                        disabled={isSubmitting}
                                        onClick={handleSubmitAnswer}
                                    >
                                        {isSubmitting ? <Loader /> : "Submit Test"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
};

// Random component
const Completionist = () => <span>Time Up!</span>;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <Completionist />;
    } else {
        // Render a countdown
        return (
            <span>
                {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
            </span>
        );
    }
};

export default ObjectiveExam;
